import { useEffect, useState } from "react";
import { Button, ButtonProps, cn } from "web-design-system";

interface Props extends ButtonProps {
  children: React.ReactNode;
  throttle: number;
  onClick: () => void;
  className?: string;
  beginOnMount?: boolean;
}

export default function ThrottledButton({
  children,
  throttle,
  onClick,
  className,
  beginOnMount = true,
  ...props
}: Props) {
  const [remainingTime, setRemainingTime] = useState(throttle);

  const [shouldThrottle, setShouldThrottle] = useState(beginOnMount);

  const [disabled, setDisabled] = useState(beginOnMount);

  useEffect(() => {
    if (!shouldThrottle) return;
    if (remainingTime > 0) {
      setTimeout(() => setRemainingTime(remainingTime - 1), 1000);
    } else {
      setDisabled(false);
    }
  }, [remainingTime, shouldThrottle]);

  return (
    <Button
      disabled={disabled}
      type="button"
      {...props}
      onClick={() => {
        onClick();
        setShouldThrottle(true);
        setDisabled(true);
        setRemainingTime(throttle);
      }}
      className={cn(className)}
    >
      {children}{" "}
      {shouldThrottle && remainingTime > 0 ? `(${remainingTime})` : ""}
    </Button>
  );
}
